// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__2VePz","total":"AdvancePaymentDetails_total__lwYaz","edit":"AdvancePaymentDetails_edit__oIl7g"};